import { render, staticRenderFns } from "./CadastroFaturamento.vue?vue&type=template&id=2b112b97"
import script from "./CadastroFaturamento.vue?vue&type=script&lang=js"
export * from "./CadastroFaturamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports